import { chatbotConstants } from '../../constants';

const initialState = {
  chatMessages: [],
};

export function chatbot(state = initialState, action) {
  switch (action.type) {
    case chatbotConstants.CHATMESSAGES:
      return {
        ...state,
        chatMessages: action.payload,
      };

    default:
      return state;
  }
}

export const getChatMessages = (state) => state.chatbot.chatMessages;
